// @ts-strict-ignore
import React, { FC } from 'react'
import classnames from 'classnames'
import { Answer } from 'mytours-read-api-typescript'
import { IonItem, IonText } from '@ionic/react'
import '../styles/textChoiceAnswer.less'

interface TextChoiceAnswerProps {
	answer: Answer
	onClick?: () => void
	isAnswered?: boolean
	isChecked?: boolean
	hasAttempts: boolean
}

const TextChoiceAnswer: FC<TextChoiceAnswerProps> = ({ answer, onClick, isChecked, isAnswered, hasAttempts }) => {
	const answerCorrect = isAnswered && answer?.correct
	const answeredIncorrect = isAnswered && isChecked && !answer?.correct

	return (
		<IonItem
			className={classnames('text-choice-answer', 'ion-align-items-center', {
				'-checked': isChecked,
				'-correct': (answerCorrect && !hasAttempts) || (hasAttempts && isChecked && answerCorrect),
				'-incorrect': answeredIncorrect,
				'-answered': isAnswered,
			})}
			onClick={!isAnswered ? onClick : null}
		>
			<div className="icon-wrapper ion-justify-content-center ion-align-items-center">
				<i
					className={classnames({
						'far fa-circle-xmark': answeredIncorrect,
						'fas fa-check': (isChecked && !isAnswered) || (answerCorrect && !isChecked && !hasAttempts),
						'far fa-circle-check': answerCorrect && isChecked,
					})}
				/>
			</div>
			<IonText>{answer?.answer_text || ''}</IonText>
		</IonItem>
	)
}

export default TextChoiceAnswer
